const addHeaderToRequestOptions = (options, header) => {
  const { headers } = options;
  return { ...options, headers: { ...headers, ...header } };
};

export default addHeaderToRequestOptions;
